import type { TrialUpgradeModel } from "../models/trial-upgrade.model"

const maxPercent = 100
const daysBeforeEndingSoonVariant = 5
const upperPercentageLimit = 95
const lowerPercentageLimit = 5

export function mapToTrialUpgradeModel(
  totalDays: number | null,
  remainingDays: number | null,
): TrialUpgradeModel {
  const variant = mapVariant(remainingDays)

  return {
    trialPeriod:
      totalDays === null || remainingDays === null
        ? null
        : {
            progressPercentage: mapTrialProgress(totalDays, remainingDays),
            remainingDays,
            totalDays,
          },
    variant,
  }
}

function mapTrialProgress(
  trialDays: number,
  remainingDays: number | null,
): number {
  const daysElapsed = trialDays - (remainingDays ?? 0)
  const percentage = Math.round((daysElapsed / trialDays) * maxPercent)

  return Math.max(
    lowerPercentageLimit,
    Math.min(upperPercentageLimit, percentage),
  )
}

function mapVariant(
  remainingDays: number | null,
): TrialUpgradeModel["variant"] {
  if (remainingDays === null) {
    return "ending-soon"
  }

  if (remainingDays <= daysBeforeEndingSoonVariant) {
    return "ending-soon"
  }

  return "default"
}
